export enum Permissions {
    BASE = "base",
}

export enum PermissionAction {
    VIEW = "view",
    EDIT = "edit",
}

export const ALL_STANDARD_PERMISSIONS_ACTIONS = [
    PermissionAction.VIEW,
    PermissionAction.EDIT,
];

export const PERMISSION_GROUPS = [
    {
        key: Permissions.BASE,
        label: "Base",
        actions: ALL_STANDARD_PERMISSIONS_ACTIONS,
    },
    // add more if needed
];
